import netDialApi from './netDialAPI'
import cstaDefs from './cstaDefs'

export {
  netDialApi,
  cstaDefs
}

export default netDialApi



// WEBPACK FOOTER //
// ./src/util/call/netDialAPI/index.js